// src/contexts/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../services/firebase";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const snap = await getDoc(doc(db, "superadmins", user.uid));
          setIsAdmin(snap.exists());
        } catch {
          setIsAdmin(false);
        }
        setCurrentUser(user);
      } else {
        setCurrentUser(null);
        setIsAdmin(false);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  async function connecter(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  async function deconnecter() {
    await signOut(auth);
  }

  return (
    <AuthContext.Provider value={{ currentUser, isAdmin, loading, connecter, deconnecter }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}